import { ReactNode } from 'react';
import { CookieConsent } from '../CookieConsent';
import Header from '../common/Header';
import { Footer } from '../common/Footer';
import { OnzoePremierWidget } from '../OnzoePremierWidget';

interface MarketingLayoutProps {
  children: ReactNode;
}

// If Header and Footer are external components, you would import their props instead:
// import { HeaderProps, FooterProps } from './components';

const MarketingLayout = ({ children }: MarketingLayoutProps) => {
  return (
    <div className="marketing-neon min-h-screen flex flex-col bg-[#F5F7FA] text-[#05070D] dark:bg-[#05070D] dark:text-white">
      <Header />
      <main className="relative flex-1 overflow-hidden bg-[#F5F7FA] text-[#05070D] dark:bg-[#05070D] dark:text-white">
        <div className="pointer-events-none fixed inset-0 z-0 opacity-[0.1] dark:opacity-20">
          <img
            src="/images/onzoe-hero.png"
            alt=""
            aria-hidden="true"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-[#F5F7FA]/88 dark:bg-[#05070D]/84" />
        </div>
        <div className="relative z-10">
          {children}
        </div>
      </main>
      <Footer />
      <CookieConsent />
      <OnzoePremierWidget />
    </div>
  )
};

export default MarketingLayout;
